import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import { toast } from 'sonner';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/');
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await api.post('/auth/google/session', { session_id: sessionId });
        login(data.token, data.user);
        toast.success(`Welcome, ${data.user.name}`);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        toast.error('Google sign-in failed');
        navigate('/');
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="flex flex-col items-center gap-6">
        <Logo size="lg" />
        <div className="flex items-center gap-2 text-[#A1A1AA]">
          <div className="w-2 h-2 rounded-full bg-[#FFB000] animate-pulse" />
          <span className="text-sm tracking-widest uppercase font-bold">Dropping the needle...</span>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
